import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { PriceSuggestion } from 'src/app/models/product-hire-estimate';
import { BookingItemService } from '../../services/booking-item.service';
import { HireablePriceUpdate } from './hireable-price-update';
@Injectable()
export class BookingItemPriceUpdateService implements HireablePriceUpdate {
  constructor(private bookingItemService: BookingItemService) {}

  update(
    parentId: number,
    lineItemId: number,
    price: number,
    pricing_type: string,
    suggestion?: PriceSuggestion,
    zeroPriceReason?: string,
    freeAccessory?: boolean
  ) {
    return this.bookingItemService
      .update(lineItemId, parentId, {
        charge: price,
        pricing_type: pricing_type,
        price_suggestion: suggestion,
        zero_price_reason: zeroPriceReason,
        free_accessory: freeAccessory
      })
      .pipe(map(() => null));
  }
}
